import React, { forwardRef, memo } from 'react';
import Chip from '@material-ui/core/Chip';
import styled, { css } from 'styled-components';

/**
 * @type {React.FC<PropsWithChildren>}
 */
const BasicChip = forwardRef((props, ref) => <StyledChip {...props} ref={ref} />);

export default memo(BasicChip);

const ChipSizes = {
  large: css`
    display: flex;
    align-items: center;
    padding: 11px 14px;
  `,
  small: css`
    padding: 3px 10px;
  `,
};

const StyledChip = styled(Chip)`
  &.MuiChip-root {
    border-radius: ${({ theme }) => theme.customized.radius.tags};
    font-family: inherit;
    font-size: 12px;
    font-weight: bold;
    height: auto;
    line-height: 13px;
    padding: 0;
  }
  .MuiChip-label {
    text-decoration: none;
    ${(props) => ChipSizes[props.size ?? 'small']};
  }
`;

StyledChip.defaultProps = {
  size: `small`,
};
